export default "__VITE_ASSET__CI76XhRu__"